import { useQuery } from "@tanstack/react-query";
import { http } from "../../../services/HttpService";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../../consts/api";

export const useStripeTaxAddress = (options = {}) => {
  const res = useQuery(
    [QUERY_KEYS.stripe.taxAddress],
    async () => http.get(HTTP_ENDPOINTS.stripe.taxAddress()),
    { select: (res) => res.data.data, ...options },
  );
  return res;
};
